import React from 'react';

import { Icon } from '@opendoor/bricks';
import './IconChecklistStyle.less';

interface IIconChecklistItem {
  iconName: string;
  content: React.ReactNode;
}

interface IIconChecklistProps {
  items: IIconChecklistItem[];
}

const IconChecklist: React.SFC<IIconChecklistProps> = (props: IIconChecklistProps) => (
  <div className="od-icon-checklist">
    {props.items.map((item, idx) => (
      <div className="od-icon-checklist__item" key={idx}>
        <Icon className="od-icon-checklist__icon" name={item.iconName} />
        {item.content}
      </div>
    ))}
  </div>
);

export default IconChecklist;
